import { ErrorState } from '@sportik/ui/components/ErrorState';
import { Component, type ReactNode } from 'react';

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  error: Error | null;
};

/**
 * The app boundary: a render that throws shows the shared error state instead
 * of a blank page. React offers no hook for this, so it stays a class.
 */
export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  override state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  override render() {
    const { error } = this.state;
    if (!error) {
      return this.props.children;
    }

    return (
      <ErrorState
        title="Something broke on this screen"
        description={error.message}
        onRetry={() => this.setState({ error: null })}
      />
    );
  }
}
